import useOrg from './useOrg';

function useIsMultipleTeamsEnabled(): boolean {
  const org = useOrg();
  return org.multipleTeamsEnabled;
}

export default useIsMultipleTeamsEnabled;
